// extracted by mini-css-extract-plugin
export default {"button":"FormButtonSuccess_button__emZ8-","checkmark":"FormButtonSuccess_checkmark__Ncwb5"};